// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__kM97t","inline":"checkbox_inline__xeeEM","container":"checkbox_container__y11C1","square":"checkbox_square__GjIw2","rotate":"checkbox_rotate__zyHL1"};